export function getHomeRoute(user) {
    return user?.role == "parent" ? "/user/parent-home" : "/user/home"
}

export default getHomeRoute
